import { getFileTemplate } from "../../utils/handler_files";

const getData = () => ({
  // personal data
  id: 0,
  profileImg: getFileTemplate(),
  name: "",
  lastName: "",
  email: "",
  tel: "",
  curp: "",
  // vehicle data
  vehicleModel: "",
  vehicleYear: 0,
  vehicleABS: false,
  vehicleAirbags: 0,
  vehicleColor: "",
  vehiclePlates: "",
  vehicleEconomicNumber: "",
  vehicleSerialNumber: "",
  vehicleFrontPhoto: getFileTemplate(),
  vehicleBackPhoto: getFileTemplate(),
  vehicleLeftPhoto: getFileTemplate(),
  vehicleRightPhoto: getFileTemplate(),
  // service capabilities
  allowsTrips: true,
  allowsShipments: true,
  // documents data
  ine: getFileTemplate(),
  driverLicence: getFileTemplate(),
  circulationCard: getFileTemplate(),
  contractRequest: getFileTemplate(),
  insurensePolicy: getFileTemplate(),
  criminalLetter: getFileTemplate(),
  address: getFileTemplate(),
  vehicleCardConstancy: getFileTemplate(),
});

const getErrorsData = () => ({
  // personal data
  profileImg: "",
  name: "",
  lastName: "",
  email: "",
  tel: "",
  curp: "",
  // vehicle data
  vehicleModel: "",
  vehicleYear: "",
  vehicleABS: "",
  vehicleAirbags: "",
  vehicleColor: "",
  vehiclePlates: "",
  vehicleEconomicNumber: "",
  vehicleSerialNumber: "",
  vehicleFrontPhoto: "",
  vehicleBackPhoto: "",
  vehicleLeftPhoto: "",
  vehicleRightPhoto: "",
  // service capabilities
  allowedServices: "",
  // documents data
  ine: "",
  driverLicence: "",
  circulationCard: "",
  contractRequest: "",
  insurensePolicy: "",
  criminalLetter: "",
  address: "",
  vehicleCardConstancy: "",
});

const getTestData = () => ({
  error: false,
  message: "",
});

export default {
  getData,
  getErrorsData,
  getTestData,
};
